import { type Debug, logger } from "@otto-ec/global-resources/debug";
import type { Log } from "../constants/log";

export class SqrlLogger<L extends Log> {
  constructor(private name: L) {}

  get logger(): Debug<L> {
    return logger(this.name);
  }

  debug(message: string) {
    this.logger.debug(message);
  }
}
